export default function SectionAbout() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
              <i className="ri-information-line"></i> 了解我们
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              关于我们
            </h2>
          </div>

          <div className="max-w-[800px] mx-auto">
            <div className="bg-background-100 rounded-2xl p-8 md:p-10">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                黑料大赛诞生于2023年，是国内领先的八卦热度排行榜聚合平台。我们致力于为用户提供最全面、最及时的娱乐八卦、网红黑料、热搜事件等热点追踪服务。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                团队成员由资深娱乐媒体人、数据分析师和内容运营专家组成。我们采用自主研发的热度算法，综合多维度数据源实时计算事件热度值，确保榜单的公正性和时效性。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们坚持「真实、及时、全面」的原则，所有上榜内容均经过多渠道交叉验证。同时我们鼓励用户投稿爆料，让每一个声音都能被听见，让每一个真相都有机会浮出水面。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                截至目前，黑料大赛已累计收录超过 2000 条热搜事件，日均服务吃瓜用户超百万，成为中文互联网最具影响力的八卦热度排行榜之一。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}